

import React  ,{useState} from "react";
import { useDispatch , useSelector} from "react-redux";

import {  modifyDisplaymodal  , modifyChampsLeadactu ,modifyChampsLeadmemo, allLeads} from "../state/redux";
import { jsonstatutscontrats } from "../utils/utils_contratwin";
import { axios_clients_updateemail } from "../axios/axios_clients";
import ButtonSimple from "./Buttons/ButtonSimple";


import {useUser } from '../state/reactquery';
import { getAllClients } from '../state/redux';
import { queryClient } from '../state/queryClient';
import { addEltHistory } from "../state/reactquery";

import { dateconvert , convertdatesignature} from "../utils/utils_dates";

import { axios_clients_updateclients } from "../axios/axios_clients";
import { axios_contrats_updatecontrat } from "../axios/axios_contrats";
import { axios_gestion_alertcontratchangestatut } from "../axios/axios_gestion";




import croixclose from '../images/croixclose.svg';
import './CardChangeEmail.scss' ;
import './CardChangeStatutContrat.scss' ;

var reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const classNames = require('classnames');


function CardChangeStatutContrat(){
    const dispatch = useDispatch()  ;
    const ficheclient = useSelector(state=>state.lead.leadactu);
    const leads = useSelector(state=>state.leads.leads);
    const [statucont,setStatucont] = useState(null) ;
    const contratchange = useSelector(state=>state.contratchange.value)  ;
   const clients = useSelector(state=>state.datagestion.clients) ;
console.log('jsonstatutscontrats',jsonstatutscontrats) ;

const changestatutcontrat = async() =>{
    console.log('CHANGECONTRAT',statucont , contratchange.etat_contrat) ;
    if(statucont===contratchange.etat_contrat){return }

    // DEV CONTRAT 

    // addEltHistory(contratchange.id_lead,'leadgagne', `<div class='horoline1' > <span className=horobold'>Lead passé en Gagné ${jsonstatutscontrats[statucont]}. </span> </div>` ) ; 
    
    // let newdatacontrat ={...contratchange:etat_contrat:statucont} ;

    // await axios_contrats_updatecontrat(newdatacontrat) ;
    // const newlead = {...leadactu,  statut_client: 'gagne_'+statutcont } ;
    // const otherleads = clients.filter(x=>x.id!==ficheclient.id) ;
    // dispatch(modifyChampsLeadactu({statut_client:'gagne_'+datacontrat.etat_contrat}));                                                       
    // axios_clients_updateclients({...newlead});
    // dispatch(getAllClients([...otherleads, newlead]));
    // contratchange?.etat_contrat!==datacontrat?.etat_contrat && axios_gestion_alertcontratchangestatut(newlead,user['nom']) ;  

    // queryClient.invalidateQueries({ queryKey: ['contrats',leadactu?.email,leadactu?.courtier]}) ;
    // queryClient.invalidateQueries({queryKey: ['allcontrats',date1, date2]}) ;

    // dispatch(modifyDisplaymodal(null));
    //await axios_contrats_updatestatutcontrat({id_contrat:ficheclient.contrat.id_contrat,newstatut:statucont}) ;
    }



    return(<div className="containergray zindexbig">
               <div className="cardchangestatutcontrat" >
                  <div className="cardchangeemail_titre"> Changement du statut du contrat.</div>

                  

                  {Object.keys(jsonstatutscontrats).map((y,i)=><button className={classNames("divmofistatutcontrat",{'selected':statucont===y})}  onClick={()=>{setStatucont(y)}} id={y} >{jsonstatutscontrats[y]}</button>)}
                                <div className='grpbtns'>
                                <ButtonSimple  texte="Annuler" containerbouton='fullbuton white' color='bouton_color_blancgris noborder' size='bouton_size_normal' onclick={()=> dispatch(modifyDisplaymodal(null)) }    />   
                                <ButtonSimple  texte="Confirmer"  containerbouton='fullbuton' color='bouton_color_orange' size='bouton_size_normal' onclick={changestatutcontrat}   />     
                  </div>
                    {/* {  confirmmodif?<>  <div className="cardchangeemail_soustitre">Ancien email</div>
                                        <div className="cardchangeemail_input" >{ficheclient?.email}</div>
                                        <div className="cardchangeemail_soustitre">Nouvel email</div>
                                        <input className="cardchangeemail_input" value={newemail} onChange={(e)=>{setNewemail(e.target.value)}  } /><br/><br/>
                                        <div className={classNames("cardchangeemail_btnorange",{"boutondisable":!reg_email.test(newemail)} )} onClick={confirmchangeemail} >Confirmer</div>
                                        <div className="cardchangeemail_btnblanc" onClick={()=>{dispatch(modifyDisplaymodal(null)) }} >Annuler</div>
                                    </>  :
                                    <>  <div className="cardchangeemail_btnorange" onClick={()=>{setConfirmmodif(true)}} >Modifier</div>
                                        <div className="cardchangeemail_btnblanc" onClick={()=>{dispatch(modifyDisplaymodal(null)) }} >Annuler</div>
                                    </>} */}
                    </div>
               
            </div>)
}

export default CardChangeStatutContrat